import axios from 'axios';
import { DoricContext } from './DoricContext';
export class DoricElement extends HTMLElement {
    constructor() {
        super();
    }
    get src() {
        return this.getAttribute('src');
    }
    get alias() {
        return this.getAttribute('alias');
    }
    set src(v) {
        this.setAttribute('src', v);
    }
    set alias(v) {
        this.setAttribute('alias', v);
    }
    connectedCallback() {
        if (this.src && this.context === undefined) {
            axios.get(this.src).then(result => {
                this.load(result.data);
            });
        }
    }
    disconnectedCallback() {
    }
    adoptedCallback() {
    }
    attributeChangedCallback() {
    }
    onDestroy() {
        var _a;
        (_a = this.context) === null || _a === void 0 ? void 0 : _a.teardown();
    }
    load(content) {
        this.context = new DoricContext(content);
        const divElement = document.createElement('div');
        divElement.style.position = 'relative';
        divElement.style.height = '100%';
        this.append(divElement);
        this.context.rootNode.view = divElement;
        this.context.init({
            width: divElement.offsetWidth,
            height: divElement.offsetHeight,
        });
    }
}
